// extracted by mini-css-extract-plugin
var _1 = "FilesGalleryActions-modulearrowLeft__iP3Jr";
var _2 = "FilesGalleryActions-modulearrowRight__vl_Lj";
var _3 = "FilesGalleryActions-modulecounter__dGFfw";
var _4 = "FilesGalleryActions-moduletextCounter__EYhfx";
export { _1 as "arrowLeft", _2 as "arrowRight", _3 as "counter", _4 as "textCounter" }
